import axiosInstance from './axiosInstance';
const API_URL = process.env.REACT_APP_API_URL;

export const getPlantRateTyres = async () => (await axiosInstance.get(`${API_URL}/plant-rate-tyres`)).data;
export const getPlantRateTyreTemplates = async () => (await axiosInstance.get(`${API_URL}/plant-rate-tyres/templates`)).data;
export const getPlantRateTyresById = async (id) => (await axiosInstance.get(`${API_URL}/plant-rate-tyres/${id}`)).data;
export const createPlantRateTyres = async (payload) => (await axiosInstance.post(`${API_URL}/plant-rate-tyres`, payload)).data;
export const updatePlantRateTyres = async (id, payload) => (await axiosInstance.put(`${API_URL}/plant-rate-tyres/${id}`, payload)).data;
export const deletePlantRateTyres = async (id) => (await axiosInstance.delete(`${API_URL}/plant-rate-tyres/${id}`)).data;
